export default __webpack_public_path__ + "static/media/tinytales.6a9f29ff.png";